import React from 'react'
import '../App.css'

import './ContainerSection.css'

const STYLES = ['container--conone', 'container--contwo']

function ContainerSection({ children, type, containerStyle }) {
  const checkContainerStyle = STYLES.includes(containerStyle)
    ? containerStyle
    : STYLES[0]

  return (
    <div className={`container ${checkContainerStyle}`} type={type}>
      {children}
    </div>
  )
}

export default ContainerSection
